/* ============================================================
   CATERPY EXPLORE
   - タブ切替（caterpy-techと同じ仕様）
   ============================================================ */

(function () {
  'use strict';

  document.querySelectorAll('.caterpy-explore').forEach(function (section) {
    var tabs = section.querySelectorAll('.caterpy-explore__tab');
    var panels = section.querySelectorAll('.caterpy-explore__panel');

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var target = tab.getAttribute('data-tab-target');

        tabs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('is-active');
        tab.setAttribute('aria-selected', 'true');

        panels.forEach(function (p) {
          if (p.getAttribute('data-tab-panel') === target) {
            p.classList.add('is-active');
          } else {
            p.classList.remove('is-active');
          }
        });
      });
    });
  });
})();